import React, { useCallback, useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { classNames } from '../../../../utils';
import EditFloorPlan from '../Popups/EditFloorPlan';
import { bedStatusAPI } from '../../../../apis';
import { Checkbox } from '../../../DutyAssign/components/Attendance/Setting';
import useBsViewSetting from '../../../../utils/useBsViewSetting';
import ActionableAlert from '../../../Admission/AdmissionSetting/ActionableAlert';
import { useActionableTicketReminder } from '../../../../utils/hooks';
import { AutoCompleteSelect } from '../../../../components';
import { CUBICLE_VIEW, CUBICLE_VIEW2, PLAIN_VIEW } from '../../../../redux/constant';
import TransferInOutRemarks from './Tabs/TransferInOutRemarks';
import CubicleRemarks from './Tabs/CubicleRemarks';
import WardRemarks from './Tabs/WardRemarks';
import TransferIn from './Tabs/TransferIn';
import ServiceOrder from './Tabs/ServiceOrder';

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: '#ffffff',
    height: '4.5rem',
    boxShadow: '0 1px 0 0 #e4e7eb',
    padding: '0 3.438rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e4e7eb',
  },
  arrowLeftIcon: {
    fontSize: '1rem',
    color: '#538fff',
  },
  back: {
    paddingLeft: '1rem',
    fontSize: '1rem',
    color: '#538fff',
    fontFamily: 'NotoSans-Bold',
  },
  editFloorPlanBtn: {
    width: '11.25rem',
    height: '2.75rem',
    borderRadius: '8px',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#fff',
  },
  tab: {
    width: '10rem',
    height: '3.875rem',
    borderRadius: '10px 10px 0 0',
    backgroundColor: 'rgba(83,143,255,0.1)',
    fontSize: '1rem',
    color: 'rgba(83,143,255,0.6)',
    fontFamily: 'NotoSans-Bold',
  },
  selected: {
    backgroundColor: '#fff',
    color: '#538fff',
  },
  version: {
    color: '#2e4469',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
}));

const Actionable = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="calc(100vh - 16rem)"
      p="1.87rem"
      borderRadius="0 15px 15px 15px"
      bgcolor="#FFF"
      overflow="auto"
    >
      <ActionableAlert />
    </Box>
  );
};

const NewBedStatusSetting = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const history = useHistory();
  const [floorPlanOpen, setFloorPlanOpen] = useState(false);
  const [wardList, setWardList] = useState([]);
  const { defaultViewType, updateViewSetting } = useBsViewSetting();
  const bedStatusViewList = [
    {
      text: PLAIN_VIEW,
      value: PLAIN_VIEW,
    },
    {
      text: CUBICLE_VIEW,
      value: CUBICLE_VIEW,
    },
    {
      text: CUBICLE_VIEW2,
      value: CUBICLE_VIEW2,
    },
  ];
  const [bedStatusViewType, setBedStatusViewType] = useState(defaultViewType);
  const { mode } = useParams();
  useActionableTicketReminder('audio', 'BS');

  const tabs = [
    { id: 0, name: 'Transfer In/ Out Remarks', component: TransferInOutRemarks },
    { id: 1, name: 'Cubicle Remarks', component: CubicleRemarks },
    { id: 2, name: 'Ward Remarks', component: WardRemarks },
    { id: 3, name: 'Transfer In', component: TransferIn },
    { id: 4, name: 'Actionable Alert', component: Actionable },
    { id: 5, name: 'Service Order', component: ServiceOrder },
  ];

  const handleSelectTab = useCallback(
    (id) => () => {
      setSelectedTab(id);
    },
    []
  );

  const Component = useMemo(() => {
    return tabs[selectedTab].component;
  }, [selectedTab]);

  const getLocationList = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getLocationList();
      setWardList(result);
      if (result.length === 1) {
        const { result: floorPlanResult } = await bedStatusAPI.createFloorPlan(result[0]);
        history.push(`/newBedstatus/editFloorPlan/${floorPlanResult.id}`);
      } else {
        setFloorPlanOpen(true);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleEditFloorPlan = () => {
    getLocationList();
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleFloorPlanOpen = (open) => () => {
    setFloorPlanOpen(open);
  };
  const handleChangeBSViewType = (val) => {
    setBedStatusViewType(val);
    updateViewSetting(val);
  };

  return (
    <div>
      <div className={classes.header}>
        <ButtonBase onClick={handleBack}>
          <ArrowLeftIcon className={classes.arrowLeftIcon} />
          <div className={classes.back}>{i18n.t('BEDSTATUS_BACK')}</div>
        </ButtonBase>
        <Box display="flex" alignItems="center" gridGap="1rem">
          <AutoCompleteSelect
            height="2.938rem"
            itemList={bedStatusViewList}
            value={bedStatusViewType}
            onChange={(val) => handleChangeBSViewType(val)}
          />
          {mode === 'cubicle' && (
            <ButtonBase className={classes.editFloorPlanBtn} onClick={handleEditFloorPlan}>
              Edit Floor Plan
            </ButtonBase>
          )}
        </Box>
      </div>
      <Box padding="1.438rem 3.438rem" bgcolor="#f1f6ff">
        <Box display="flex" gridGap="0.625rem">
          {tabs.map((item) => (
            <ButtonBase
              className={selectedTab === item.id ? classNames(classes.tab, classes.selected) : classes.tab}
              key={item.id}
              id={`tab_${item.id}`}
              onClick={handleSelectTab(item.id)}
            >
              {item.name}
            </ButtonBase>
          ))}
        </Box>
        <Component />
      </Box>
      {floorPlanOpen && <EditFloorPlan handleFloorPlanOpen={handleFloorPlanOpen} wardList={wardList} />}
    </div>
  );
};

export default NewBedStatusSetting;
